(function () {
  if (window.__hpLaunch) return;
  window.__hpLaunch = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobileMax = 760;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('is-visible');
    });
  }, { threshold: 0.14 });

  document.querySelectorAll('.hp-in, .hp-serve').forEach(function (el) {
    if (reduce) el.classList.add('is-visible');
    else revealObserver.observe(el);
  });

  var hero = document.querySelector('[data-hp-hero]');
  if (hero && document.querySelector('[data-hp-shopbar]')) {
    var shopbarObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        document.documentElement.classList.toggle('hp-shopbar-on', !entry.isIntersecting);
      });
    }, { threshold: 0.12 });
    shopbarObserver.observe(hero);
  }

  var purpose = document.querySelector('[data-hp-purpose]');
  var purposeSteps = Array.prototype.slice.call(document.querySelectorAll('[data-hp-purpose-step]'));
  var purposeBars = Array.prototype.slice.call(document.querySelectorAll('[data-hp-purpose-bar]'));
  var purposeBgs = Array.prototype.slice.call(document.querySelectorAll('[data-hp-purpose-bg]'));
  var making = document.querySelector('[data-hp-making]');
  var makingSteps = Array.prototype.slice.call(document.querySelectorAll('[data-hp-making-step]'));
  var makingBgs = Array.prototype.slice.call(document.querySelectorAll('[data-hp-making-bg]'));

  function idx(container, count) {
    if (!container || window.innerWidth < mobileMax + 1) return 0;
    var rect = container.getBoundingClientRect();
    var travel = Math.max(1, rect.height - window.innerHeight);
    var progress = clamp(-rect.top / travel, 0, 0.9999);
    return Math.min(count - 1, Math.floor(progress * count));
  }

  function activate(items, index) {
    items.forEach(function (el, n) {
      el.classList.toggle('is-active', n === index);
    });
  }

  function render() {
    document.querySelectorAll('[data-hp-parallax]').forEach(function (el) {
      var parent = el.parentElement;
      if (!parent) return;
      var rect = parent.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
      var speed = Number(el.getAttribute('data-hp-parallax') || 0);
      var center = rect.top + rect.height / 2 - window.innerHeight / 2;
      el.style.transform = 'translate3d(0,' + (center * -speed) + 'px,0)';
    });

    var purposeIndex = idx(purpose, purposeSteps.length);
    activate(purposeSteps, purposeIndex);
    activate(purposeBars, purposeIndex);
    activate(purposeBgs, purposeIndex);

    var makingIndex = idx(making, makingSteps.length);
    activate(makingSteps, makingIndex);
    activate(makingBgs, makingIndex);
  }

  if (!reduce) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        render();
        ticking = false;
      });
    }, { passive: true });
    window.addEventListener('resize', render);
    render();
  }

  document.querySelectorAll('[data-hp-flavour]').forEach(function (root) {
    var notes = Array.prototype.slice.call(root.querySelectorAll('[data-hp-note]'));
    var copy = root.querySelector('[data-hp-flavour-copy]');
    function noteOn(note) {
      notes.forEach(function (other) {
        other.classList.toggle('is-active', other === note);
      });
      if (copy) copy.textContent = note.getAttribute('data-copy') || '';
    }
    notes.forEach(function (note) {
      note.addEventListener('mouseenter', function () { noteOn(note); });
      note.addEventListener('focus', function () { noteOn(note); });
      note.addEventListener('click', function () { noteOn(note); });
    });
  });

  document.querySelectorAll('[data-hp-video]').forEach(function (video) {
    if (reduce) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  });

  var pause = document.querySelector('[data-hp-pause]');
  var heroVideo = document.querySelector('[data-hp-hero] [data-hp-video]');
  if (pause && heroVideo) {
    pause.addEventListener('click', function () {
      if (heroVideo.paused) {
        var play = heroVideo.play();
        if (play && play.catch) play.catch(function () {});
      } else heroVideo.pause();
    });
  }

  document.querySelectorAll('[data-hp-pick]').forEach(function (root) {
    var main = root.querySelector('[data-hp-pick-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hp-pick-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (other) {
          other.classList.toggle('is-active', other === thumb);
        });
        if (main) main.src = thumb.getAttribute('data-src') || main.src;
      });
    });
  });

  var routeSection = document.querySelector('.shopify-section.section-hub-routes, .shopify-section.section-about-nav, .shopify-section.section-gs-nav');
  var routeLinks = Array.prototype.slice.call(document.querySelectorAll('[data-oh-route]'));

  if (routeSection) {
    var headerEl = document.getElementById('shopify-section-header') || document.querySelector('store-header');
    var stickyRaf = 0;

    var syncOhStickyTop = function () {
      stickyRaf = 0;
      if (!headerEl) {
        routeSection.style.removeProperty('--oh-sticky-top');
        return;
      }
      var bottom = Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom));
      routeSection.style.setProperty('--oh-sticky-top', bottom + 'px');
      document.documentElement.style.setProperty('--oh-sticky-top', bottom + 'px');
    };

    var queueStickySync = function () {
      if (stickyRaf) return;
      stickyRaf = window.requestAnimationFrame(syncOhStickyTop);
    };

    queueStickySync();
    window.addEventListener('scroll', queueStickySync, { passive: true });
    window.addEventListener('resize', queueStickySync);

    if (headerEl && 'ResizeObserver' in window) {
      var headerResize = new ResizeObserver(queueStickySync);
      headerResize.observe(headerEl);
      if (headerEl.firstElementChild) headerResize.observe(headerEl.firstElementChild);
    }

    if (headerEl && 'MutationObserver' in window) {
      var headerMutate = new MutationObserver(queueStickySync);
      headerMutate.observe(headerEl, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        subtree: true
      });
    }
  }

  if (routeLinks.length && 'IntersectionObserver' in window) {
    var routeSections = routeLinks.map(function (link) {
      return {
        link: link,
        section: document.getElementById(link.getAttribute('data-oh-route'))
      };
    }).filter(function (item) { return item.section; });
    var routeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        routeLinks.forEach(function (link) { link.classList.remove('is-active'); });
        var match = routeSections.find(function (item) { return item.section === entry.target; });
        if (match) {
          match.link.classList.add('is-active');
          try {
            match.link.scrollIntoView({ block: 'nearest', inline: 'center' });
          } catch (e) {}
        }
      });
    }, { rootMargin: '-38% 0px -50% 0px', threshold: 0 });
    routeSections.forEach(function (item) { routeObserver.observe(item.section); });
  }
})();
